import React from "react";
import {
  HiOutlineLocationMarker, // Icono de ubicación más formal
  HiOutlineMail, // Icono de email más formal
  HiOutlinePhone, // Icono de teléfono más formal
} from "react-icons/hi";
import logo from "../../images/logotypes/Cancelarte Vertical Verde@4x.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Sección Superior */}
        <div className="footer-top">
          {/* Nosotros */}
          <div className="footer-section">
            <h3 className="section-title">Nosotros</h3>
            <p className="section-text">
              Abogados especializados en deudas bancarias y financieras con más
              de 20 años de experiencia en el rubro. Te ayudamos a negociar,
              cancelar o refinanciar tus deudas para que puedas volver a tener
              una vida financiera en orden.
            </p>
          </div>

          {/* Logo Centrado */}
          <div className="footer-logo">
            <img src={logo} alt="Cancelarte" className="logo-img" />
          </div>

          {/* Contacto */}
          <div className="footer-section">
            <h3 className="section-title">Contacto</h3>
            <div className="contact-info">
{/*               <div className="contact-item">
                <HiOutlineLocationMarker className="contact-icon" />
                <span>Güemes 4426, CP 1425, Capital Federal</span>
              </div> */}
              <div className="contact-item">
                <HiOutlineMail className="contact-icon" />
                <span>cancelarte.info@gmail.com</span>
              </div>
              <div className="contact-item">
                <HiOutlinePhone className="contact-icon" />
                <span>+54 911 6278-7796</span>
              </div>
            </div>
          </div>
        </div>

        {/* Sección Inferior */}
        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} Copyright:{" "}
            <span className="company-name">cancelarte.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
